/**
 * Safe frontend release identity exposed on window.__RIESTRO_RELEASE__.
 * Values come from CRA build-time env vars only — never secrets or API config.
 */

function envOrUnknown(key) {
  const value = process.env[key];
  if (typeof value === 'string' && value.trim() !== '') {
    return value.trim();
  }
  return 'unknown';
}

/**
 * @returns {{ app: string, git_sha: string, build_time: string, release_name: string }}
 */
export function buildReleaseIdentity() {
  return {
    app: 'riestro-frontend',
    git_sha: envOrUnknown('REACT_APP_GIT_SHA'),
    build_time: envOrUnknown('REACT_APP_BUILD_TIME'),
    release_name: envOrUnknown('REACT_APP_RELEASE_NAME'),
  };
}

/**
 * @param {Window | undefined} target
 * @returns {{ app: string, git_sha: string, build_time: string, release_name: string }}
 */
export function installReleaseIdentity(target = typeof window !== 'undefined' ? window : undefined) {
  const identity = buildReleaseIdentity();
  if (target) {
    target.__RIESTRO_RELEASE__ = identity;
  }
  return identity;
}
